import fr from "./lang/fr.json";
import it from "./lang/it.json";
import { createI18n } from "vue-i18n";

const i18n = createI18n({
  locale: import.meta.env.VITE_LANG_VERSION ?? "fr",
  allowComposition: true,
  fallbackLocale: "fr",
  messages: {fr, it},
});

export default i18n;
